import store from "../stores/store"

// initialis l'itntercepteur axios pour recharger la page si une 401/419 est retourné
axios.interceptors.response.use(response => response, error => {
    if (error.response.status === 401 || error.response.status === 419) {
        let originalRequest = error.config

        // essaie une nouvelle fois la requête et recharge la page si elle échoue
        // (permet d'éviter les erreurs réseaux)
        if (originalRequest._retry) {
            location.reload()
        } else {
            originalRequest._retry = true
            return axios(originalRequest)
        }
    }

    return Promise.reject(error)
})

export default {
    /**
     * Applique le middleware
     */
    handle: (to, from, next) => {
        if (store.state.auth.checked || to.path === '/login') {
            if (to.path === '/login' && store.state.auth.checked) {
                next({name: 'dossiers'})
            }
        } else {
            next({name: 'login'})
        }
    }
}
